import React, { useState, useContext } from "react";
import axios from "axios";
import moment from "moment";
import DataTable from "react-data-table-component";
import { NotificationManager } from "react-notifications";
import { makeStyles } from "@mui/styles";
import LinearProgress from "@mui/material/LinearProgress";
import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
import { deleteLorawanthread } from "services/ConfigServices";
import CustomDeleteButton from "components/CustomDeleteButton/CustomDeleteButton.js";
import UserService from "services/UserService";
import Button from "components/CustomButtons/Button.js";
import styled from "styled-components";
import AdvancedSearchContext from "context/AdvancedSearchContext";
import { lorawanthreadtext } from "variables/MBM/lorawanthread";
import { lorawanthreadtypeData } from "variables/MBM/lists/lorawanthread";
import Dialog from "@mui/material/Dialog";
import { withStyles } from "@mui/styles";
import MuiDialogContent from "@mui/material/DialogContent";
import MuiDialogActions from "@mui/material/DialogActions";
import CustomDialogTitle from "components/Dialog/CustomDialogTitle.js";

import useLorawanThreadsTable from "./useLorawanThreadsTable.js";
import LorawanThreadDialog from "./LorawanThreadDialog.js";



const NoData = styled.p`
  font-size: 14px;
  font-weight: 600;
  margin-top: 20px;
  opacity: 1;
`;


const DialogContent = withStyles((theme) => ({
  root: {
    padding: '16px',
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: '8px',
  },
}))(MuiDialogActions);

const useStyles = makeStyles(styles);

const RTLorawanThread = () => {
  const permis = JSON.parse(localStorage.getItem("permission")) || [];
  const currentusertype = localStorage.getItem('userType');
  const mbm_admin = permis.includes("mbm_admin") && currentusertype == 1; //not in prod yet
  const appContext = useContext(AdvancedSearchContext);
  const { chartIdGroup, groupInfoListById } = appContext;
  const [open, setOpen] = useState(false);
  const [currentLorawanThread, setCurrentLorawanThread] = useState(null);
  const { gridState, refetch, setLorawanthreads } = useLorawanThreadsTable();

  let dataLorawanthreads = gridState.data;

  const classes = useStyles();
  const columns = [
    {
      name: lorawanthreadtext.id,
      selector: (row) => row.id,
      sortable: true,
      maxWidth: "5rem",
      cell: (row) => row.id,
    },
    {
      name: lorawanthreadtext.servertype,
      selector: (row) => lorawanthreadtypeData.find((x) => x.id == row.servertype)?.name || "",
      sortable: true,
      maxWidth: "8rem",
      cell: (row) => lorawanthreadtypeData.find((x) => x.id == row.servertype)?.name || ""
    },
    {
      name: lorawanthreadtext.frequency,
      selector: (row) => row.frequency,
      sortable: true,
      maxWidth: "8rem",
      cell: (row) => row.frequency + "mn",
    },
    {
      name: lorawanthreadtext.group,
      selector: (row) => groupInfoListById["" + row.groupid] || "",
      sortable: true,
      maxWidth: "10rem",
      cell: (row) => groupInfoListById["" + row.groupid] || ""
    },
    {
      name: lorawanthreadtext.lastrun,
      selector: (row) => row.lastrun,
      sortable: true,
      maxWidth: "12rem",
      cell: (row) =>
        row.lastrun && moment(row.lastrun).isValid()
          ? <Tooltip title={lorawanthreadtext.lastlog}>{moment(row.lastrun).format("DD/MM/YYYY HH:mm:ss")}</Tooltip>
          : "",
    },
    {
      name: "",
      sortable: false,
      width: "12rem",
      // eslint-disable-next-line react/button-has-type
      // eslint-disable-next-line react/display-name
      cell: (row) => (
        <>
          <div className="actions-right">
            {mbm_admin && (
              <>
                <Tooltip title={lorawanthreadtext.edition}>
                  <Button
                    onClick={editLorawanthread(row)}
                    color={"warning"}
                    className={classes.actionButton}
                  >
                    <EditIcon fontSize="large" />
                  </Button>
                </Tooltip>
                <Tooltip title={lorawanthreadtext.del}>
                  <CustomDeleteButton
                    deleteTitle={lorawanthreadtext.del}
                    deleteSubTitle={lorawanthreadtext.delconfirm}
                    handleSupprimer={deleteLorawanthreadFunction(row)}
                  />
                </Tooltip></>
            )}
          </div>
        </>
      ),
    },
  ];


  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleEditClose = () => {
    setOpen(false);
  };

  const editLorawanthread = (row) => async () => {
    let obj = dataLorawanthreads.find((o) => o.id === row.id);
    if (obj) {
      setCurrentLorawanThread(obj);
      handleClickOpen();
    }
  }

  const deleteLorawanthreadFunction = (row) => async () => {
    let obj = dataLorawanthreads.find((o) => o.id === row.id);
    let idSelected = obj.id;
    let url = deleteLorawanthread(idSelected);
    axios
      .delete(url,
        {
          headers: {
            Authorization: `Bearer ${UserService.getToken()}`,
          },
        })
      .then((res) => {
        if (res.status == 200) {
          setNotification(
            "success",
            lorawanthreadtext.delok
          );
          refetch();
        } else setNotification("error", "Une erreur est survenue");
      })
      .catch((error) => {
        setNotification("error", "Une erreur est survenue");
      });
  };

  const setNotification = (status, text) => {
    if (status === "success") {
      NotificationManager.success(text);
    } else {
      NotificationManager.error(text);
    }
  };

  const handleSelectedRowsChange = (selection) => {
    setLorawanthreads(selection.selectedRows);
  };


  return (
    <>
      <DataTable
        paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
        noDataComponent={<NoData>{lorawanthreadtext.nothread}</NoData>}
        noHeader={true}
        columns={columns}
        persistTableHead
        pagination
        subHeader
        onSelectedRowsChange={handleSelectedRowsChange}
        selectableRows={true}
        progressPending={gridState.loading}
        progressComponent={<LinearProgress />}
        paginationComponentOptions={{
          noRowsPerPage: false,
          rowsPerPageText: "Lignes par page",
          rangeSeparatorText: "sur",
          selectAllRowsItem: false,
          selectAllRowsItemText: "Selectionner toutes les lignes",
        }}
        {...gridState}
      />
      <Dialog
        onClose={handleEditClose}
        aria-labelledby="edituser-dialog-title"
        fullWidth="true"
        maxWidth="md"
        open={open}
      >
        <CustomDialogTitle id="customized-dialog-title" onClose={handleEditClose}>
          {lorawanthreadtext.edition}
        </CustomDialogTitle>
        <DialogContent dividers>
          <LorawanThreadDialog
            currentLorawanThread={currentLorawanThread}
            closeModal={handleEditClose}
            refetch={refetch}
          />
        </DialogContent>
        <DialogActions></DialogActions>
      </Dialog>
    </>
  );
};

export default RTLorawanThread;
